<template>
<div v-if="documentSet" class="document-set-header well clearfix">
    <h1>{{ documentSet.name }}</h1>
    <div v-if="documentSet.owners" class="owners">
        <span class="user-label">For</span>
        <div v-for="owner in documentSet.owners" class="owner">{{owner.user.firstName}} {{owner.user.lastName}}</div>
    </div>
    <div v-if="documentSet.attorneys" class="more-info collapse clearfix" id="moreInfoBlock">
        <div class="flexbox">
            <div class="attorneys well col-xs-12" v-bind:class="documentSet.staff.length ? 'col-sm-6' : ''">
                <div v-for="attorney in documentSet.attorneys" class="attorney clearfix">
                    <div class="headshot-col col-md-3 col-md-offset-0 col-xs-6 col-xs-offset-3">
                        <img v-bind:src="attorney.user.pictureFileThumbUrl" alt="" class="img-circle img-responsive headshot">
                    </div>
                    <div class="col-md-9 col-xs-12">
                        <h2 class="user-label">Attorney<span v-if="documentSet.attorneys.length!=1">s</span></h2>
                        <div class="info-block">
                            <h4>{{attorney.user.firstName}} {{attorney.user.lastName}}</h4>
                            <p><a v-bind:href="'mailto:'+attorney.user.email">{{attorney.user.email}}</a></p>
                            <p><a v-bind:href="'tel:'+attorney.user.contacts.phone1">{{ attorney.user.contacts.phone1 }}</a></p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="documentSet.staff.length" class="staff col-sm-6 col-lg-6 col-xs-12 well">
                <h2 class="user-label">Paralegals/Assistants</h2>
                <ul class="staff-list">
                    <li v-for="staff in documentSet.staff" class="info-block">
                        <h4>{{ staff.user.firstName }}{{ staff.user.lastName }}</h4>
                        <p><a v-bind:href="'mailto:' + staff.user.email" title="">{{ staff.user.email }}</a></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <a v-if="documentSet.attorneys" class="more-btn" type="button" data-toggle="collapse" data-target="#moreInfoBlock" aria-expanded="false" aria-controls="moreInfoBlock"><i class="fa fa-chevron-circle-down"></i></a>
</div>
</template>
<script>
export default {
name: 'documentSetHeader',
props: ['documentSet']
}
</script>
<style lang="scss" scoped>@import "../variables";
.flexbox {
  display: block;
  padding: 0;
  padding-bottom: 1em;
  @media(min-width: $screen-sm-min) {
    display: flex;
    & {
      .attorneys,
      .staff {
        margin: 0 8px;
      }
    }
  }
  @media(min-width: $screen-md-min) {
    padding: 0 3vw 1em;
  }
}

.document-set-header {
  margin-top: 1rem;
  position: relative;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 1.5rem;
  color: #999;
}

h1 {
  margin: 0;
  line-height: 1;
  margin-bottom: .5rem;
}

.owners {
  margin-top: .3rem;
  margin-bottom: 1em;
  font-size: 1.2em;
  .owner {
    display: inline-block;
    &:after {
      content: "•";
      padding: 0 .5em;
    }
    &:last-child:after {
      content: '';
      padding: 0;
    }
  }
}

.attorney {
  img {
    margin: 0 auto;
  }
}

.staff {
  .staff-list {
    margin-top: 0;
  }
}

.attorneys,
.staff {
  h2 {
    margin-top: .5em;
    text-align: center;
    font-size: 1.3em;
    @media(min-width: $screen-md-min) {
      margin-top: 0;
      text-align: left;
    }
  }
  ul.staff-list {
    list-style: none;
    padding-left: 0;
    @media(min-width: $screen-md-min) {
      list-style: initial;
      padding-left: 1rem;
    }
  }

  &.well {
    background-color: #f9f9f9;
  }
}

.user-label {
  margin: 0 0 .3em 0;
  text-align: left;
  line-height: 1;
}

.info-block {
  font-size: .85em;
  line-height: 1.6;
  @media (min-width: $screen-lg-min) {
    // font-size: 1em;
  }
  * {
    margin: 0;
    text-align: center;
    @media (min-width: $screen-md-min) {
      text-align: left;
    }
  }
  h4 {
    margin-top: .5em;
    @media (min-width: $screen-md-min) {
      margin: 0;
    }
  }
}

.headshot-col {
  padding-left: 0;
  padding-right: 0;
}

.more-btn {
  font-size: 2rem;
  cursor: pointer;
  color: #ccc;
  &[aria-expanded=true] {
    i.fa::before {
      content: "\F139";
    }
    i.fa::after {
      content: "";
    }
  }
  i.fa::after {
    display: block;
    font-family: sans-serif;
    font-size: .7rem;
    color: #666;
    content: "more info";
  }
}

</style>



// WEBPACK FOOTER //
// DocumentSetHeader.vue?0bfe4c3f